import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { BdFeaturesPermissionsAdminStore } from '../store/features-admin.store';
import { Observable } from 'rxjs';
import {
  FeaturePermissionObj,
  ShareTargetType,
} from '@bindoc-projects/resource-domain-lib';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class BdFeaturePermissionAdminService {
  private _httpClient = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private _store: BdFeaturesPermissionsAdminStore;

  constructor() {
    this._store = new BdFeaturesPermissionsAdminStore(this._environmentService.load(ApiEndpointKey.BD_PERMISSION_RESOURCE_URL));
  }

  public getAllPermissions(
    shareTargetType: ShareTargetType,
    shareTargetId: string,
  ): Observable<{
    shareTargetId: string;
    shareTargetType: ShareTargetType;
    permissions: `${string}:${string}`[];
  }> {
    const url = this._store.getAllPermissions(shareTargetType, shareTargetId);
    return this._httpClient.get<{
      shareTargetId: string;
      shareTargetType: ShareTargetType;
      permissions: `${string}:${string}`[];
    }>(url);
  }

  public createFeaturePermission(
    granteeType: ShareTargetType,
    granteeId: string,
    permission: `${string}:${string}`,
    expiresAt?: Date
  ): Observable<FeaturePermissionObj> {
    return this._httpClient.post<FeaturePermissionObj>(
      this._store.featurePermissions(),
      {
        "permission": permission,
        "granteeId": granteeId,
        "granteeType": granteeType,
        "expiresAt": expiresAt ? expiresAt.toISOString() : undefined
      }
    );
  }

  public revokeFeaturePermission(
    granteeType: ShareTargetType,
    granteeId: string,
    permission: `${string}:${string}`
  ): Observable<void> {
    return this._httpClient.delete<void>(
      this._store.featurePermissions(),
      {
        body: {
          "permission": permission,
          "granteeId": granteeId,
          "granteeType": granteeType,
        }
      }
    );
  }
}
